import React, { useEffect, useState, useRef } from 'react';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import FormPageHeading from '../../../../common/molecule/FormPageHeading';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import theme from '../../../../../../../../styles/themes/TCP';
import styles from '../styles/BIAOrderHistory.style';
import withStyles from '../../../../../../common/hoc/withStyles';
import BIATIleView from '../molecules/BIATIle.view';
import internalEndpoints from '../../../../common/internalEndpoints';
import BUY_IT_AGAIN_BAG_PAGE_CONSTANTS from '../../../../../CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.constants';
import GlobalCartItemTileLabels, {
  GLOBAL_CART_ITEM_TILE_LABELS,
  lblViewAll,
} from '../../../../../../../utils/labels/globalCartItemTile.labels';
import {
  ACCOUNT_COMMON_CONSTANT,
  BIAOrderHistoryLabels,
  lblBiaOrderHistoryMainTitle,
} from '../container/BIAOrderHistory.labels';

const { breakpoints } = theme;
const getCarouselOptions = (carouselRef) => {
  return {
    autoplay: false,
    arrows: true,
    autoplaySpeed: 4000,
    infinite: false,
    initialSlide: 0,
    fade: false,
    speed: 300,
    dots: true,
    dotsClass: 'slick-dots',
    slidesToShow: 7,
    slidesToScroll: 7,
    ref: carouselRef,
    responsive: [
      {
        breakpoint: 2561,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 12,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 2300,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 9.2,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 2100,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 9.2,
          slidesToScroll: 8,
        },
      },
      {
        breakpoint: 1800,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 8.2,
          slidesToScroll: 8,
        },
      },
      {
        breakpoint: 1700,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 6.2,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 5.2,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: parseInt(breakpoints.large, 10) - 1,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 7.2,
          slidesToScroll: 7,
        },
      },
      {
        breakpoint: parseInt(breakpoints.mediumMax, 10) - 1,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 6.2,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 900,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 5.2,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: parseInt(breakpoints.medium, 10) - 1,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 6.2,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: parseInt(breakpoints.medium, 10) - 60,
        settings: {
          autoplay: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 5.2,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 500,
        settings: {
          autoplay: false,
          arrows: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 3.2,
          slidesToScroll: 2,
          dots: false,
        },
      },
    ],
  };
};

const BIAOrderHistoryView = (props) => {
  const {
    className,
    biaProducts,
    getBIAConfigData,
    onQuickViewOpenClick,
    isLoggedIn,
    getBIABagPageProducts,
    setBIAAvailableProductActn,
  } = props;
  const [productArr, setProductArr] = useState([]);
  const [products, setProducts] = useState([]);
  const carouselRef = useRef(null);
  useEffect(() => {
    const biaBagPageCategoryCode = getBIAConfigData?.categoryCode;
    if (!biaProducts?.length) return;
    const cachedProducts =
      biaProducts && Array.isArray(biaProducts)
        ? biaProducts?.find(
            (buyItAgainProduct) => buyItAgainProduct.categoryCode === biaBagPageCategoryCode
          )
        : {};
    setProducts(cachedProducts?.buyItAgainProducts || []);
  }, [biaProducts]);

  useEffect(() => {
    if (isLoggedIn) {
      getBIABagPageProducts();
    }
  }, [isLoggedIn]);

  const getFormattedProducts = (product) => {
    if (!product) return null;
    return {
      dimension66: `bia-bag|items-${products?.length}`,
      ...product,
    };
  };
  useEffect(() => {
    if (!products?.length) return;
    const prodArr = products?.map((buyItAgainProduct) => getFormattedProducts(buyItAgainProduct));
    setProductArr(prodArr);
    setBIAAvailableProductActn(prodArr.length > 0);
  }, [products]);
  const next = () => {
    carouselRef?.current?.slickNext();
  };
  const prev = () => {
    carouselRef?.current?.slickPrev();
  };

  const shouldShowShopAllLink = () => {
    let isShouldShowShopAllLink = true;
    const { biaInitialApiActualProductCount } = props;
    const biaCarouselStaticProductCount = getBIAConfigData?.noOfProducts;
    const biaBagPageCarousalProductLength = productArr?.length;
    const biaInitialApiProductCountStatic =
      BUY_IT_AGAIN_BAG_PAGE_CONSTANTS?.BUY_IT_AGAIN_INITIAL_API_PRODUCT_COUNT_STATIC;
    if (
      biaInitialApiActualProductCount < biaInitialApiProductCountStatic &&
      biaBagPageCarousalProductLength < biaCarouselStaticProductCount
    ) {
      isShouldShowShopAllLink = false;
    } else if (
      biaInitialApiActualProductCount < biaInitialApiProductCountStatic &&
      biaBagPageCarousalProductLength > biaCarouselStaticProductCount
    ) {
      isShouldShowShopAllLink = true;
    } else if (biaInitialApiActualProductCount >= biaInitialApiProductCountStatic) {
      isShouldShowShopAllLink = true;
    }
    return isShouldShowShopAllLink;
  };
  return (
    <div className={className}>
      {productArr?.length > 0 && (
        <div className="bia-wrapper elem-mb-SM elem-mt-SM">
          <FormPageHeading
            className="elem-mb-XL bia-page-heading"
            toPathUrl={internalEndpoints.buyItAgain.link}
            asPathUrl={internalEndpoints.buyItAgain.path}
            labelValue={getLabelFromCopyOrFromTranslation(
              `${GLOBAL_CART_ITEM_TILE_LABELS}.${lblViewAll}`,
              GlobalCartItemTileLabels
            )}
            heading={getLabelFromCopyOrFromTranslation(
              `${ACCOUNT_COMMON_CONSTANT}.${lblBiaOrderHistoryMainTitle}`,
              BIAOrderHistoryLabels
            )}
            next={next}
            prev={prev}
            showCta={shouldShowShopAllLink()}
          />

          <div className="bia-container">
            <React.Fragment>
              <BodyCopy
                component="div"
                className={`${className} orders-carousel-tablet-desktop-view orders-redesign-carousel-new`}
              >
                <Carousel
                  options={getCarouselOptions(carouselRef)}
                  carouselConfig={{
                    arrow: 'small',
                    type: 'light',
                  }}
                  carouselTheme="dark"
                >
                  {productArr?.map((item) => (
                    <BIATIleView biaProduct={item} onQuickViewOpenClick={onQuickViewOpenClick} />
                  ))}
                </Carousel>
              </BodyCopy>
              <BodyCopy
                component="div"
                className={`${className} orders-carousel-mobile-view orders-redesign-carousel-new`}
              >
                <Carousel
                  options={getCarouselOptions(carouselRef)}
                  carouselConfig={{
                    customArrowLeft: null,
                    customArrowRight: null,
                    arrow: 'small',
                    type: 'light',
                  }}
                  carouselTheme="dark"
                >
                  {productArr?.map((item) => (
                    <BIATIleView biaProduct={item} onQuickViewOpenClick={onQuickViewOpenClick} />
                  ))}
                </Carousel>
              </BodyCopy>
            </React.Fragment>
          </div>
        </div>
      )}
    </div>
  );
};
export default withStyles(BIAOrderHistoryView, styles);
export { BIAOrderHistoryView as BIAOrderHistoryViewlVanilla };
